/*
 *   Copyright (c) 2020 BuserNet Consulting LLC
 *   All rights reserved.
 */
import ApiConstant from '../constants/api.constant';
import AppConst from '../constants/app.constant';
import { processNewMetar } from './metar/processMetar';
import httpService from './http.service';
import { getServiceHostPreference } from './utils/getServiceHostPreference';

const metarDataService = () => {
  let isGettingMeetarData = false;
  let metarDataObj;
  let allMetarDataObj;
  let metarDataLoadedAt;
  let allPoints = [];
  let allMetarMap = {};

  function isMetarDataValid() {
    // This function resets METAR data if it is older than metarRequestAge
    const currentTime = window.performance.now();
    if ((currentTime - metarDataLoadedAt) >= AppConst.metarRequestAge) {
      metarDataObj = null;
      allMetarDataObj = null;
      metarDataLoadedAt = null;
      allPoints = null;
      allMetarMap = {};
    }
  }
  const getNewMetarDataRemote = async () => {
    const data = await httpService.http_get(
      `${getServiceHostPreference()}${ApiConstant.newMetarApiA}?bncachebuster=${Date.now()}`,
    );
    return processNewMetar(data);
  };
  const getMetarDataRemote = async () => {
    if (!isGettingMeetarData) {
      isGettingMeetarData = true;
      const metarData = await getNewMetarDataRemote();
      isGettingMeetarData = false;
      if (metarData) {
        allMetarDataObj = metarData.allMetarData;
      }
      if (metarData && metarData.metars) {
        metarDataObj = metarData.metars;
        allPoints = metarData.points;
        allMetarMap = metarData.allMetarMap;
        metarDataLoadedAt = window.performance.now();
      }
    }
    return true;
  };
  const content = {};
  content.getMetarDataModel = () => ({
    metarDataObj,
    allMetarDataObj,
    allPoints,
    allMetarMap,
  });
  content.getData = async () => {
    if (metarDataObj) {
      isMetarDataValid();
    }
    if (!metarDataObj) {
      await getMetarDataRemote();
    }
    return content.getMetarDataModel();
  };
  return content;
};
export default metarDataService();
